import { createReducer, on } from '@ngrx/store';
import { ApiCategory, CatalogLayout, CatalogSort } from '../../core/models';
import { AuthActions } from '../auth/auth.actions';
import { CatalogActions } from './catalog.actions';

export interface CatalogFilters {
  query: string;
  category: string;
  sort: CatalogSort;
  inStockOnly: boolean;
  layout: CatalogLayout;
}

export interface CatalogState {
  activeId: string | null;
  filters: CatalogFilters;
  /** Live categories (each with its products) from the smartAsset store API. */
  categories: ApiCategory[];
  categoriesLoading: boolean;
  categoriesLoaded: boolean;
  categoriesError: string | null;
}

export const initialCatalogState: CatalogState = {
  activeId: null,
  filters: {
    query: '',
    category: 'All',
    sort: 'featured',
    inStockOnly: false,
    layout: 'grid',
  },
  categories: [],
  categoriesLoading: false,
  categoriesLoaded: false,
  categoriesError: null,
};

export const catalogReducer = createReducer(
  initialCatalogState,

  on(CatalogActions.loadCategoryInfo, (state) => ({
    ...state,
    categoriesLoading: true,
    categoriesError: null,
  })),
  on(CatalogActions.loadCategoryInfoSuccess, (state, { categories }) => ({
    ...state,
    categories,
    categoriesLoading: false,
    categoriesLoaded: true,
  })),
  on(CatalogActions.loadCategoryInfoFailure, (state, { error }) => ({
    ...state,
    categoriesLoading: false,
    categoriesError: error,
  })),

  on(CatalogActions.setQuery, (state, { query }) => ({
    ...state,
    filters: { ...state.filters, query },
  })),
  on(CatalogActions.clearQuery, (state) => ({
    ...state,
    filters: { ...state.filters, query: '' },
  })),
  on(CatalogActions.setCategory, (state, { category }) => ({
    ...state,
    filters: { ...state.filters, category },
  })),
  on(CatalogActions.setSort, (state, { sort }) => ({
    ...state,
    filters: { ...state.filters, sort },
  })),
  on(CatalogActions.toggleInStockOnly, (state) => ({
    ...state,
    filters: { ...state.filters, inStockOnly: !state.filters.inStockOnly },
  })),
  on(CatalogActions.setLayout, (state, { layout }) => ({
    ...state,
    filters: { ...state.filters, layout },
  })),
  on(CatalogActions.resetFilters, (state) => ({
    ...state,
    filters: { ...state.filters, query: '', category: 'All', inStockOnly: false },
  })),

  on(CatalogActions.openProduct, (state, { id }) => ({ ...state, activeId: id })),

  on(AuthActions.logout, () => initialCatalogState),
);
